<template>
    <div
        :class="`modal ${className}`"
        v-show="visible"
    >
        <div
            class="modal__background"
            @click="close"
        />
        <div class="modal__foreground">
            <div class="modal__header">
                <h2 class="modal__title">
                    {{ title }}
                </h2>
                <button
                    class="modal__close"
                    @click.prevent="close"
                >
                    <i class="fa fa-times" />
                </button>
            </div>

            <div class="modal__body">
                <slot name="default" />
            </div>

            <div class="modal__footer">
                <slot name="footer" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            required: true,
            type: String,
        },
        className: {
            required: false,
            type: String,
            default: '',
        }
    },
    
    data() {
        return {
            visible: false,
        };
    },

    methods: {
        close() {
            this.$emit('close');
            this.visible = false;
        },

        open() {
            this.$emit('open');
            this.visible = true;
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/modals/ModalComponent.vue